import { take } from '@execonline-inc/collections';
import { when } from '@execonline-inc/maybe-adapter';
import { fromEmpty } from 'maybeasy';
import { observer } from 'mobx-react';
import { emptyFragment } from '../../../../../../../../EmptyFragment';
import { T } from '../../../../../../../../Translations';
import { ProductLicenseResource } from '../../../../../../Types';
import LearningCollectionEditStore from '../../../../../Edit/Store';
import { filteredScheduledProgramInstanceOptions } from '../../../DateSelection';
import { ExperienceResource } from '../../Types';
import ExcessStartDates from './ExcessStartDates';
import StartDate from './StartDate';

export interface Props {
  resource: ExperienceResource;
  learningCollectionStore: LearningCollectionEditStore;
  productLicense: ProductLicenseResource;
}

function AvailableStartDates({ resource, learningCollectionStore, productLicense }: Props) {
  return fromEmpty(
    filteredScheduledProgramInstanceOptions(
      resource.payload.programInstanceOptions.scheduled,
      productLicense,
      learningCollectionStore,
    ),
  )
    .map((options) => {
      return (
        <>
          <div className="mb-5 flex text-sm font-semibold">
            <T kind="Available Start Dates" />
          </div>
          <div className="mb-5 grid grid-cols-4">
            {take(4, options).map((scheduledOption) => (
              <StartDate scheduledOption={scheduledOption} key={scheduledOption.id} />
            ))}
            {when((options) => options.length > 4, options)
              .map((options) => <ExcessStartDates options={options} />)
              .getOrElse(emptyFragment)}
          </div>
        </>
      );
    })
    .getOrElse(emptyFragment);
}

export default observer(AvailableStartDates);
